import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export interface Toast {
  id: number;
  type: ToastType;
  message: string;
  durationMs: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  toasts = this._toasts.asReadonly();
  private uid = 1;

  show(message: string, type: ToastType = 'info', durationMs = 3000) {
    const id = this.uid++;
    const toast: Toast = { id, type, message, durationMs };
    this._toasts.update((list) => [toast, ...list]);

    // auto-dismiss
    setTimeout(() => this.dismiss(id), durationMs);
  }

  success(msg: string, d = 3000) {
    this.show(msg, 'success', d);
  }
  error(msg: string, d = 4000) {
    this.show(msg, 'error', d);
  }
  info(msg: string, d = 3000) {
    this.show(msg, 'info', d);
  }
  warning(msg: string, d = 3500) {
    this.show(msg, 'warning', d);
  }

  dismiss(id: number) {
    this._toasts.update((list) => list.filter((t) => t.id !== id));
  }

  clear() {
    this._toasts.set([]);
  }
}
